import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getDevice } from '@panel/commons/helpers';
import { Container, Title, PlanItem, RadioCircle, PlanContent, PlanName, Tag, Available } from './styles';

const PlanSelector = ({ plans = [], handleFieldChange, register, hasPlanSelected = null, dataPubli = '' }) => {
  const { t } = useTranslation();
  const device = getDevice();
  const [selectedPlanId, setSelectedPlanId] = useState(hasPlanSelected || plans?.[0]?.id);
  const previousPlanIdsRef = useRef(null);

  // Actualizamos selectedPlanId cuando los planes cambian realmente (cambio de branch), no en cada render
  useEffect(() => {
    const currentPlanIds = plans?.map(plan => plan.id).join(',');
    const plansChanged = previousPlanIdsRef.current !== null && previousPlanIdsRef.current !== currentPlanIds;

    if (plansChanged || previousPlanIdsRef.current === null) {
      // Buscamos el plan con selected: true
      const selectedPlan = plans?.find(plan => plan.selected);
      if (selectedPlan && selectedPlan.id !== selectedPlanId) {
        setSelectedPlanId(selectedPlan.id);
      }
    }

    previousPlanIdsRef.current = currentPlanIds;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plans]);

  // Actualizamos el formulario cuando cambia el plan seleccionado
  useEffect(() => {
    if (selectedPlanId) {
      handleFieldChange('plan', selectedPlanId, { shouldDirty: false });
      handleFieldChange('plan_name', plans.find(plan => plan.id === selectedPlanId)?.name || '', {
        shouldDirty: false
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlanId, handleFieldChange]);

  return (
    <Container device={device} data-publi='plan-selector'>
      <Title data-publi={`${dataPubli}-subtitle`}>{t('professionalPubli.publish.plansSelector.title')}</Title>
      <input type='hidden' value={selectedPlanId} {...register('plan')} />
      {plans.map(plan => (
        <PlanItem
          key={plan.id}
          selected={selectedPlanId === plan.id}
          onClick={() => {
            handleFieldChange('plan', plan.id);
            handleFieldChange('plan_name', plan.name);
            setSelectedPlanId(plan.id);
          }}
          device={device}
          data-publi={`${dataPubli}-item-${plan.id}`}
        >
          <RadioCircle selected={selectedPlanId === plan.id} data-publi={`${dataPubli}-circle-${plan.id}`} />
          <PlanContent data-publi={`${dataPubli}-content-${plan.id}`} device={device}>
            <PlanName device={device} data-publi={`${dataPubli}-name-${plan.id}`}>
              {plan.name}
            </PlanName>
            <Tag data-publi={`${dataPubli}-tag-${plan.id}`}>{plan.visibility}</Tag>
            <Available data-publi={`${dataPubli}-available-${plan.id}`}>
              {t('professionalPubli.publish.plansSelector.availablePlans')} <span>{plan.available}</span>
            </Available>
          </PlanContent>
        </PlanItem>
      ))}
    </Container>
  );
};

export default PlanSelector;
